import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import axios from "axios";
import "./MHEROIntelligent.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const MHEROIntelligent = () => {
  const { currentLang } = useContext(LanguageContext);
  const [mheroIntelligent, setMheroIntelligent] = useState(null);
  const [loading, setLoading] = useState(true);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchMheroIntelligent = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${API_BASE}/api/MheroIntelligentSection?lang=${currentLang}`
        );
        setMheroIntelligent(res.data);
      } catch (err) {
        console.error("Error fetching MHERO Intelligent section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMheroIntelligent();
  }, [currentLang]);

  if (loading) return <div className="mhero-loading">Loading...</div>;
  if (!mheroIntelligent)
    return <div className="mhero-error">No MHERO Intelligent data found.</div>;

  const styleMHEROIntelligent = {
    backgroundImage: mheroIntelligent.imageUrl
      ? `url(${resolveUrl(mheroIntelligent.imageUrl)})`
      : "none",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    aspectRatio: "4 / 3",
    width: "100%",
  };

  return (
    <div className="MHEROIntelligent" style={styleMHEROIntelligent}>
      <div className="MI-wrapper">
        <h1>{mheroIntelligent.title}</h1>
        <p>{mheroIntelligent.description}</p>
      </div>
    </div>
  );
};

export default MHEROIntelligent;
